// extracted by mini-css-extract-plugin
module.exports = {"base":"GenreCard_base__upNiU"};